import type {
    RepeatableDomainAdapterContext,
    RepeatableGroupDomainAdapter,
    RepeatableInfoDialogView,
    RepeatableRowExtraView,
} from '../../interfaces/input.interface';

export interface ReactiveRepeatableDomainAdapterFactoryConfig {
    readonly getNumericInputClasses?: (ctx: RepeatableDomainAdapterContext, key: string) => Record<string, boolean>;
    readonly getRowExtraView?: (ctx: RepeatableDomainAdapterContext) => RepeatableRowExtraView;
    readonly canOpenInfoDialog?: (ctx: RepeatableDomainAdapterContext) => boolean;
    readonly getInfoDialogView?: (ctx: RepeatableDomainAdapterContext) => RepeatableInfoDialogView | null;
}

/** Builds repeatable domain adapters while preserving strict optional property semantics. */
export class ReactiveRepeatableDomainAdapterFactory {
    public static create(config: ReactiveRepeatableDomainAdapterFactoryConfig): RepeatableGroupDomainAdapter {
        return {
            ...(config.getNumericInputClasses !== undefined ? {
                getNumericInputClasses: config.getNumericInputClasses,
            } : {}),
            ...(config.getRowExtraView !== undefined ? { getRowExtraView: config.getRowExtraView } : {}),
            ...(config.canOpenInfoDialog !== undefined ? { canOpenInfoDialog: config.canOpenInfoDialog } : {}),
            ...(config.getInfoDialogView !== undefined ? { getInfoDialogView: config.getInfoDialogView } : {}),
        };
    }

    public static rowExtraView(
        getRowExtraView: (ctx: RepeatableDomainAdapterContext) => RepeatableRowExtraView,
    ): RepeatableGroupDomainAdapter {
        return this.create({ getRowExtraView });
    }
}
